import { mapActionsLazy, mapGettersLazy } from '@/plugins/helper'
import { FOLLOWED_ITEM } from '@/utils/enums/personal-area'

export const followInterests = {
  computed: {
    ...mapGettersLazy({
      profileSettings: 'personal-area/profileSettings'
    }),
    $_followInterests_followedTagCount() {
      return this.$_followInterests_getFollowedItemsCount(
        this.profileSettings.Tags
      )
    },
    $_followInterests_followedAuthorCount() {
      return this.$_followInterests_getFollowedItemsCount(
        this.profileSettings.Authors
      )
    },
    $_followInterests_followedCompanyCount() {
      return this.$_followInterests_getFollowedItemsCount(
        this.profileSettings.Companies
      )
    },
    $_followInterests_followedCategoryCount() {
      return this.profileSettings.ParentCategories.reduce(
        (acc, parentCategory) =>
          acc +
          this.$_followInterests_getFollowedItemsCount(
            parentCategory.Categories
          ),
        0
      )
    },
    $_followInterests_countArray() {
      return [
        this.$_followInterests_followedTagCount,
        this.$_followInterests_followedAuthorCount,
        this.$_followInterests_followedCompanyCount,
        this.$_followInterests_followedCategoryCount
      ]
    },
    $_followInterests_isFollowedCountsReceived() {
      return this.$_followInterests_countArray.every(value => value !== null)
    },
    $_followInterests_isNoFollowedItems() {
      return this.$_followInterests_countArray.every(value => value === 0)
    },
    $_followInterests_followActions() {
      return {
        [FOLLOWED_ITEM.TAGS]: {
          FOLLOW: this.requestFollowFmTags,
          UNFOLLOW: this.requestUnfollowFmTags
        },
        [FOLLOWED_ITEM.CATEGORIES]: {
          FOLLOW: this.requestFollowFmCategories,
          UNFOLLOW: this.requestUnfollowFmCategories
        },
        [FOLLOWED_ITEM.AUTHORS]: {
          FOLLOW: this.requestFollowFmAuthors,
          UNFOLLOW: this.requestUnfollowFmAuthors
        },
        [FOLLOWED_ITEM.COMPANIES]: {
          FOLLOW: this.requestFollowFmCompanies,
          UNFOLLOW: this.requestUnfollowFmCompanies
        }
      }
    }
  },
  methods: {
    ...mapActionsLazy({
      requestFollowFmTags: 'personal-area/requestFollowFmTags',
      requestFollowFmCompanies: 'personal-area/requestFollowFmCompanies',
      requestFollowFmAuthors: 'personal-area/requestFollowFmAuthors',
      requestFollowFmCategories: 'personal-area/requestFollowFmCategories',
      requestUnfollowFmTags: 'personal-area/requestUnfollowFmTags',
      requestUnfollowFmCompanies: 'personal-area/requestUnfollowFmCompanies',
      requestUnfollowFmAuthors: 'personal-area/requestUnfollowFmAuthors',
      requestUnfollowFmCategories: 'personal-area/requestUnfollowFmCategories'
    }),
    $_followInterests_getFollowedItemsCount(items) {
      return items.filter(({ IsFollowed }) => IsFollowed).length
    },
    async $_followInterests_toggleCategoryItem(
      parentCategory,
      category,
      isFollowed
    ) {
      const selectedCategoriesCount = parentCategory.Categories.filter(
        ({ IsFollowed }) => IsFollowed
      ).length
      const isAddedFirstCategory = selectedCategoriesCount === 0 && isFollowed
      const isRemovedLastCategory = selectedCategoriesCount === 1 && !isFollowed

      try {
        const Ids = [
          category.Id,
          ...(isAddedFirstCategory || isRemovedLastCategory
            ? [parentCategory.ParentCategoryId]
            : [])
        ]
        await (isFollowed
          ? this.$_followInterests_followActions[
              FOLLOWED_ITEM.CATEGORIES
            ].FOLLOW({
              payload: { Ids }
            })
          : this.$_followInterests_followActions[
              FOLLOWED_ITEM.CATEGORIES
            ].UNFOLLOW({
              payload: { Ids }
            }))
        this.$emit('refresh-profile-summary')
      } catch (err) {
        throw err
      }
    },
    $_followInterests_getIdsOnParentCategoryToggle(parentCategory, isFollowed) {
      return [
        ...parentCategory.Categories.filter(
          ({ IsFollowed }) => IsFollowed !== isFollowed
        ).map(({ Id }) => Id),
        ...(parentCategory.IsFollowed === isFollowed
          ? []
          : [parentCategory.ParentCategoryId])
      ]
    },
    async $_followInterests_toggleParentCategoryItem(
      parentCategory,
      isFollowed
    ) {
      try {
        const Ids = this.$_followInterests_getIdsOnParentCategoryToggle(
          parentCategory,
          isFollowed
        )
        await (isFollowed
          ? this.$_followInterests_followActions[
              FOLLOWED_ITEM.CATEGORIES
            ].FOLLOW({
              payload: { Ids }
            })
          : this.$_followInterests_followActions[
              FOLLOWED_ITEM.CATEGORIES
            ].UNFOLLOW({
              payload: { Ids }
            }))
        this.$emit('refresh-profile-summary')
      } catch (err) {
        throw err
      }
    },
    async $_followInterests_toggleFollowingItem(itemName, id, isFollowed) {
      try {
        const Ids = Array.isArray(id) ? [...id] : [id]
        await (isFollowed
          ? this.$_followInterests_followActions[itemName].FOLLOW({
              payload: { Ids }
            })
          : this.$_followInterests_followActions[itemName].UNFOLLOW({
              payload: { Ids }
            }))
        this.$emit('refresh-profile-summary')
      } catch (err) {
        throw err
      }
    }
  }
}
